import {
    $body,
    $window,
    getRelativeUrl,
    jqGetElemById,
} from 'util/global';
import contentModal from 'app/content_modal';


/**
 * handles popstate event on solvable/note/set pages
 */
export function handler() {
    let initialURL = getRelativeUrl();

    $window.on('popstate', (e) => {
        if (contentModal.popstateHandlerHook()) {
            initialURL = getRelativeUrl();
            return;
        }

        const contentUrl = getRelativeUrl();

        if (contentUrl !== initialURL) {
            if (e.state && e.state.modalContent) {
                // try to open the content in a modal
                const $modal = jqGetElemById('nf-feeditem-modal');
                const $root = ($modal.length > 0 && $modal.is(':visible') ? $modal : $body);
                const $modalLink = $root.find(`.modal-link[href="${contentUrl}"]`);

                if ($modalLink.length > 0) {
                    contentModal.urlStack.push(initialURL);
                    initialURL = contentUrl;
                    $modalLink.trigger('click');
                    return;
                }
            }

            initialURL = contentUrl;
            // just redirect if nothing else worked
            window.location.href = window.location.href; // eslint-disable-line no-self-assign
        }
    });
}
